import classNames from "classnames";

import { DetailField } from "./integrationMessageUtils";

const formatValue = (value: DetailField["value"]) => {
  if (value === null || value === undefined || value === "") return null;
  return String(value);
};

const IntegrationMessageDetail = ({
  detailFields,
}: {
  detailFields: DetailField[];
}) => {
  return (
    <div className="IntegrationMessageDetail">
      {detailFields.map(({ label, value }) => {
        const formatted = formatValue(value);
        return (
          <div className="IntegrationMessageDetail__field" key={label}>
            <h3 className="IntegrationMessageDetail__label">{label}</h3>
            <span
              className={classNames("IntegrationMessageDetail__value", {
                "IntegrationMessageDetail__value--empty": formatted === null,
              })}
            >
              {formatted ?? "not set"}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default IntegrationMessageDetail;
